import SuccessRecharge from './styles'
export default SuccessRecharge